<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t('location_change_request.title') }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="isValid" ref="form" lazy-validation>
        <v-flex><h3>{{ $t('location_change_request.select_machine') }}</h3></v-flex>
        <v-checkbox
          v-for="machine in machines"
          v-model="selectedMachines"
          :label="`${machine.franchisee_machine_code} (${machine.franchisee_machine_reports[0].report_name})`"
          :value="machine.id"
          :key="machine.id"
          dense
          :rules="[rules.required]"
          required
        ></v-checkbox>
        <v-flex><h3>{{ $t('location_change_request.confirm_select_machine') }}</h3></v-flex>
        <v-flex>
          <v-checkbox
            dense
            v-model="isNeedStorage"
            :label="$t('location_change_request.agree_storage')"
          ></v-checkbox>
        </v-flex>
        <v-flex>
          <v-checkbox
            dense
            v-model="isAgreeTnc"
            :label="$t('location_change_request.agree_tnc')"
            :rules="[rules.agree]"
            required
          ></v-checkbox>
        </v-flex>
        <ul>
          <li>{{ $t('location_change_request.tnc_1') }}</li>
          <li>{{ $t('location_change_request.tnc_2') }}</li>
          <li>{{ $t('location_change_request.tnc_3') }}</li>
          <li>{{ $t('location_change_request.tnc_4') }}</li>
          <li>{{ $t('location_change_request.tnc_5') }}</li>
          <li>{{ $t('location_change_request.tnc_6') }}</li>
          <li>{{ $t('location_change_request.tnc_7') }}</li>
        </ul>
        <v-flex>
          <span class="hint">* {{ $t('location_change_request.hint') }}</span>
        </v-flex>
        <v-flex>
          <span class="hint">* {{ $t('location_change_request.hint2') }}</span>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="submitLoading"
            @click="submit"
          >{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import locationChangeRequestService from '@/services/locationChangeRequest'

export default {
  data () {
    return {
      submitLoading: false,
      isValid: false,
      rules: {
        agree: value => !!value || this.$t('location_change_request.must_agree'),
        required: value => !!value.length || this.$t('required')
      },
      selectedMachines: [],
      isNeedStorage: false,
      isAgreeTnc: false
    }
  },

  computed: {
    machines () {
      let result = []
      for (let key in this.$store.state.machinesData) {
        let machine = this.$store.state.machinesData[key]
        if (machine.franchisee_location) {
          result.push(machine)
        }
      }
      return result
    }
  },

  created () {
    this.reload()
  },

  methods: {
    reload () {
    },

    async submit () {
      if (!this.isValid || !this.$refs.form.validate()) {
        return
      }

      this.submitLoading = true
      try {
        await locationChangeRequestService.store({
          franchisee_machine_ids: this.selectedMachines,
          is_need_storage: this.isNeedStorage,
          is_agree_tnc: this.isAgreeTnc
        })
        this.reload()
        this.$toasted.success(this.$t('location_change_request.request_success')).goAway(7000)
      } catch (error) {
        this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.submitLoading = false
        this.$refs.form.reset()
      }
    }

  }
}
</script>
